"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformOrganizationTokenScopes = void 0;
/**
 * Scopes for access to organizations on ShapeDiver Geometry Backend systems.
 */
var SdPlatformOrganizationTokenScopes;
(function (SdPlatformOrganizationTokenScopes) {
    /**
     * Group scope "group.analytics" (analytics permissions for organization).
     */
    SdPlatformOrganizationTokenScopes["GroupAnalytics"] = "group.analytics";
})(SdPlatformOrganizationTokenScopes = exports.SdPlatformOrganizationTokenScopes || (exports.SdPlatformOrganizationTokenScopes = {}));
//# sourceMappingURL=SdPlatformOrganizationTokenScopes.js.map